import React, { useEffect, useState } from 'react'
import Header from '../components/Header'
import axiosInstance from '../utils/axiosInstance';
import Session from "../utils/sessionStorage";
import ConsentCheckModal from '../components/Home/ConcentCheckModal';
import ErrorModal from '../components/ErrorModal';
import nodata from "../assets/images/nodata.png";
import downlineBadge from "../assets/svgs/downline-badge.svg";

// Recursive TreeNode component to display hierarchical customer data
const TreeNode = ({ node, level = 0, isLast = false }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const hasChildren = node.children && node.children.length > 0;
    // const dummyData = [
    //                 {
    //                     "id": "01k3qd4pc88zh649aengcemejw",
    //                     "name": "NUR FARAHIYAH BINTI RAMLAN",
    //                     "phone": "60108451165",
    //                     "children": [
    //                         {
    //                             "id": "01k3g2qetq81jsksf4f291kwx3",
    //                             "name": "NUR FARAHIYAH BINTI RAMLAN",
    //                             "phone": "601113341430",
    //                             "children": [
    //                                 {
    //                                     "id": "01k3g2qetq81jsksf4f291kwx3",
    //                                     "name": "NUR FARAHIYAH BINTI RAMLAN",
    //                                     "phone": "601113341430",
    //                                     "children": [
    //                                         {
    //                                             "id": "01k3g2qetq81jsksf4f291kwx3",
    //                                             "name": "NUR FARAHIYAH BINTI RAMLAN",
    //                                             "phone": "601113341430",
    //                                             "children": []
    //                                         }
    //                                     ]
    //                                 }
    //                             ]
    //                         },
    //                         {
    //                             "id": "01k3g2qetq81jsksf4f291kwx3",
    //                             "name": "NUR FARAHIYAH BINTI RAMLAN",
    //                             "phone": "601113341430",
    //                             "children": []
    //                         },
    //                         {
    //                             "id": "01k3g2qetq81jsksf4f291kwx3",
    //                             "name": "NUR FARAHIYAH BINTI RAMLAN",
    //                             "phone": "601113341430",
    //                             "children": []
    //                         }
    //                     ]
    //                 },
    //                 {
    //                     "id": "01k3g2qetq81jsksf4f291kwx3",
    //                     "name": "NUR FARAHIYAH BINTI RAMLAN",
    //                     "phone": "601113341430",
    //                     "children": []
    //                 },
    //                 {
    //                     "id": "01k1hnmcr7ww95e1rgab4xnmvy",
    //                     "name": "SITI RAIHANAH BINTI JEFRI",
    //                     "phone": "601120511362",
    //                     "children": []
    //                 },
    //                 {
    //                     "id": "01k1d6w141qcpjdh59mw41z86m",
    //                     "name": "NUR FARAHIYAH BINTI RAMLAN",
    //                     "phone": "60108451166",
    //                     "children": []
    //                 },
    //                 {
    //                     "id": "01k0dkkbpghenmy8hgzrkwrm6p",
    //                     "name": "NUR FARAHIYAH BINTI RAMLAN",
    //                     "phone": "601113454044",
    //                     "children": []
    //                 },
    //                 {
    //                     "id": "01jy618yhc1jpys7xdj33cssnh",
    //                     "name": "NUR FARAHIYAH BINT RAMLAN",
    //                     "phone": "60108572455",
    //                     "children": []
    //                 },
    //                 {
    //                     "id": "01jxt5eykjsdn56dskjei1ry",
    //                     "name": "RUBIAH SHUBIRULWI",
    //                     "phone": "601120511362",
    //                     "children": []
    //                 },
    //                 {
    //                     "id": "01jw40cswa2w6bex1fzk3267fq",
    //                     "name": "Saif Ur Rehman",
    //                     "phone": "601113454044",
    //                     "children": []
    //                 }
    //             ]

    const toggleExpand = () => {
        if (hasChildren) {
            setIsExpanded(!isExpanded);
        }
    };

    return (
        <div className="flex w-full">
            {/* Tree Lines Container */}
            {level > 0 && (
                <div className="relative w-5 flex-shrink-0">
                    {/* Vertical line from parent */}
                    {!isLast && (
                        <div className="absolute left-3 top-0 bottom-0 border w-[2px] bg-gray-400 z-30 border-black/25"></div>
                    )}

                    {/* Vertical line only to current node if last child */}
                    {isLast && (
                        <div className="absolute left-3 top-0 h-[50px] border w-[2px] bg-gray-400 border-black/25"></div>
                    )}

                    {/* Horizontal line connecting to node */}
                    <div className="absolute left-3 top-[50px] border w-3 h-[2px] border-black/25">
                        <svg
                            className={`w-4 h-4 text-black/25 absolute -top-2 left-0 transition-transform `}
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg></div>

                </div>
            )}

            {/* Content */}
            <div className="flex-1 min-w-0">
                {/* Current Node */}
                <div className="mt-4">
                    <div
                        className={`flex items-center justify-between p-3 rounded-[8px] transition-all ${level === 0
                            ? 'bg-primary/10'
                            : 'bg-primary/5 ml-1'
                            }`}
                    >
                        <div className="flex items-center gap-2 flex-1 min-w-0">
                            {/* Expand/Collapse Icon */}
                            {hasChildren ? (
                                <button
                                    onClick={toggleExpand}
                                    className="focus:outline-none transition-transform duration-200 flex-shrink-0"
                                >
                                    <svg
                                        className={`w-5 h-5 ${level === 0 ? 'text-primary' : "text-[#2c2e2c]"} transition-transform ${isExpanded ? 'rotate-90' : ''}`}
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                </button>
                            ) : (
                                <div className="w-4 h-4 flex-shrink-0"></div>
                            )}

                            {/* Customer Info */}
                            <div className="flex-1 min-w-0">
                                <h3 className={`font-semibold truncate ${level === 0 ? 'text-primary text-[17px]' : level === 1 ? 'text-[#2c2e2c] text-[15px]' : 'text-[#4a4c4e] text-[15px]'}`}>
                                    {node.name}
                                </h3>
                                <p className="text-[#818486] text-[11px] font-semibold">{node.phone}</p>
                            </div>

                            {/* Badge Icon - Only for child nodes */}
                            {level > 0 && (
                                <div className="flex-shrink-0 relative">
                                    <img
                                        src={downlineBadge}
                                        alt="badge"
                                        className="w-5 h-5"
                                    />
                                    <span className="absolute -top-1 z-50 inset-0 flex items-center justify-center text-primary  text-[7px] font-bold">
                                        0{level}
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Children Nodes */}
                {isExpanded && hasChildren && (
                    <div>
                        {node.children.map((child, index) => (
                            <TreeNode
                                key={child.id || index}
                                node={child}
                                level={level + 1}
                                isLast={index === node.children.length - 1}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

const ReferralList = () => {
    const [customersDownline, setCustomersDownline] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errorModal, setErrorModal] = useState({ open: false, message: "" });
    const token = Session.get("token");

    async function getCustomersDownline() {
        setLoading(true);
        try {
            const response = await axiosInstance.get("/api/v1/get-customers-downline", {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.status === 200) {
                const data = response?.data?.customers_downline || [];
                setCustomersDownline(data

                );
                console.log("Customers downline data: ", data);
            }
        } catch (error) {
            console.log("Error: ", error?.response?.data?.message);
            setErrorModal({
                open: true,
                message: error?.response?.data?.message || "Failed to load customers downline"
            });
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getCustomersDownline();
    }, []);

    // Loading state
    if (loading) {
        return <ConsentCheckModal />
    }

    // Empty state
    if (customersDownline?.length === 0) {
        return (
            <>
                <Header />
                <div className="max-w-md mx-auto px-4">
                    <div className="flex flex-col justify-center bg-white mt-[33px] h-44 rounded-lg mb-3">
                        <div className="mx-auto">
                            <img src={nodata} alt="no data" className="w-full h-full" />
                        </div>
                        <p className="font-poppins text-base font-medium text-accent-silver-900 text-center">
                            No Referral Data Found
                        </p>
                    </div>
                </div>
            </>
        )
    }

    return (
        <div className="bg-accent-grey-50 min-h-screen">
            <Header />

            <div className="max-w-md mx-auto px-4 py-6 bg-[#2E31910D] rounded-[24px] mt-5 overflow-hidden">

                <div className="overflow-x-hidden">
                    {customersDownline.map((customer, index) => (
                        <TreeNode
                            key={customer.id || index}
                            node={customer}
                            level={0}
                            isLast={index === customersDownline.length - 1}
                        />
                    ))}
                </div>
            </div>

            {/* Error Modal */}
            {errorModal.open && (
                <ErrorModal
                    open={errorModal.open}
                    setOpen={() => setErrorModal({ open: false, message: "" })}
                    message={errorModal.message}
                />
            )}
        </div>
    )
}

export default ReferralList
